export default __webpack_public_path__ + "static/media/15095@2x.4d479115.png";